import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { IsValidPermissions } from "../../Routes/AuthProtected";
import AdminDashboard from "./AdminDashboard";
import EmployeeDashboard from "./EmployeeDashboard";
import ClientDashboard from "./ClientDashboard";
import ProcurementDashboard from "./ProcurementDashboard";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container } from "reactstrap";

// function DashboardRoute() {
//     const navigate = useNavigate(); // Get the navigate function

//     useEffect(() => {
//         if (IsValidPermissions(['VIEW_ADMIN_DASHBOARD']) === true) {
//             // Redirect to the admin dashboard
//             navigate("/admin-dashboard");
//         }
//         if (IsValidPermissions(['VIEW_EMPLOYEE_DASHBOARD']) === true) {
//             // Redirect to the employee profile using getEmployeeUUID
//             navigate(`/employee-dashboard`);
//         }
//     }, []);

//     return null; // You can return null, as you don't need to render anything in this component
// }

const DashboardRoute = () => {
  const navigate = useNavigate();
  const canViewAdmin = IsValidPermissions(["VIEW_ADMIN_DASHBOARD"]);
  const canViewEmployee = IsValidPermissions(["VIEW_EMPLOYEE_DASHBOARD"]);
  const canViewLta = IsValidPermissions(["VIEW_LTA_DASHBOARD"]);
  const canViewProcurement = IsValidPermissions(["VIEW_ALL_PURCHASE_DASHBOARD"]);
  // useEffect(() => {
  //     if (IsValidPermissions(['VIEW_ADMIN_DASHBOARD']) === true) {
  //         // Redirect to the admin dashboard
  //         navigate("/admin-dashboard");
  //     }
  //     if (IsValidPermissions(['VIEW_EMPLOYEE_DASHBOARD']) === true) {
  //         // Redirect to the employee profile using getEmployeeUUID
  //         navigate(`/employee-dashboard`);
  //     }
  // }, []);

  return (
    <React.Fragment>
      {canViewAdmin ? <AdminDashboard /> : null}

      {canViewEmployee ? (
        <EmployeeDashboard />
      ) : null}

      {canViewLta ? <ClientDashboard /> : null}

      {canViewProcurement && !canViewAdmin && !canViewEmployee && !canViewLta ? (
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title="Procurement Dashboard" pageTitle="Dashboard" />
            <ProcurementDashboard />
          </Container>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default DashboardRoute;
